// extracted by mini-css-extract-plugin
export default {"wrapper":"SmallRelatedProducts_wrapper__iQq5b","heading":"SmallRelatedProducts_heading__RiyfY","product":"SmallRelatedProducts_product__6LUTK"};